import {
    IAnimationControllerConfiguration,
    Inject,
    ISimpleControllerConfiguration,
    SimpleBaseController,
} from '@denishussar/html5-game-engine';
import { GameModel } from '../../../../Models/GameModel';
import { GameLogic } from '../../../../Logic/GameLogic';
import { Graphics, Point } from 'pixi.js';
import { remapValue } from '../../../../Common/Utils';

export interface IGameObstacleProjectionControllerOptions {
    index: number;
    roadIndex: number;
}

export class GameObstacleProjectionController extends SimpleBaseController {
    $model: GameModel;

    private _projectionScale: number[] = [0.3, 8];

    private _index: number = 0;
    public _roadIndex: number = 0;

    private _size: number = 8;
    private _graphics: Graphics;

    public constructor(
        @Inject private _options: IGameObstacleProjectionControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('GameObstacleProjectionController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <ISimpleControllerConfiguration>{};
    }

    protected onInitialize(): void {
        this._index = this._options.index;
        this._roadIndex = this._options.roadIndex;
        this.visible = false;
        // this._graphics = new Graphics();
        // this._graphics.beginFill(0x00ff00);
        // this._graphics.drawCircle(0, 0, this._size);
        // this._graphics.endFill();

        // this.visible = false;// set true for debug

        // this.display.addChild(this._graphics);
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    protected onUpdate(frameRate: number) {
        // const globalPoint = this.display.parent.toGlobal(this.display.position);

        // this.display.scale.set(remapValue(globalPoint.y,
        //     this.renderer.renderer.height * 0.3, this.renderer.renderer.height,
        //     this._projectionScale[0], this._projectionScale[1]
        // ));
    }

    public getIndex(): number {
        return this._index;
    }

    public getRoadIndex(): number {
        return this._roadIndex;
    }
}
